export const addChartAddonWithdrawals = ({ chart, data }) => {
  if (
    !chart?.xAxis?.[0]?.min ||
    !chart?.xAxis?.[0]?.max ||
    !chart.plotLeft ||
    !chart.plotWidth ||
    !chart.plotHeight ||
    chart.renderTo.clientWidth === 0
  ) {
    return;
  }

  window.chart = chart;
  requestAnimationFrame(() => {
    if (!chart?.xAxis?.[0]?.min || !chart?.xAxis?.[0]?.max) return;

    // Clean up existing elements
    chart.overlayContainer?.remove();

    // Create main container
    const overlayContainer = document.createElement("div");

    overlayContainer.style.cssText = `
      height: ${chart.plotHeight}px;
      left: ${chart.plotLeft}px;
      position: absolute;
      top: ${chart.plotTop}px;
      width: ${chart.plotWidth}px;
      z-index: 3;
    `;
    chart.container.appendChild(overlayContainer);
    chart.overlayContainer = overlayContainer;

    const xAxis = chart.xAxis[0];

    // add markers under xAxis
    if (data.length) {
      data.map((it, index) => {
        const sameYearsQuantity = data.filter(
          dataItem => dataItem.date === it.date
        ).length;

        const marker = document.createElement("div");
        marker.classList.add("chart-marker");
        marker.style.cssText = `
          top: ${chart.plotHeight + 30}px;
          left: ${
            xAxis.toPixels(it.date, true) + sameYearsQuantity * index * 2
          }px;
          position: absolute;
          transform: translateX(-50%);
          z-index: ${data.length - index};
        `;

        marker.innerHTML = `
          <svg  xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
            <path d="M9.74976 1.29721C10.5104 -0.0808092 12.4911 -0.0808072 13.2517 1.29721L22.4207 17.9085C23.1564 19.2415 22.1923 20.875 20.6697 20.875H2.33175C0.809207 20.875 -0.154981 19.2415 0.580778 17.9085L9.74976 1.29721Z" fill="${it.color}"/>
          </svg>
        `;

        chart.overlayContainer.appendChild(marker);
      });
    }
  });
};
